export const RFL_AUTOMATION_LABEL = "RFL Automation";
